/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Recyclepumpsecs4Inputs */



/**
* | output |
* | --- |
* | "ECS recirculation pumps" |
*
* @param {Br_History_Key_Recyclepumpsecs4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_recyclepumpsecs4 = /** @type {((inputs?: Br_History_Key_Recyclepumpsecs4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Recyclepumpsecs4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ECS recirculation pumps")
	return /** @type {LocalizedString} */ ("Pompes de recyclage ECS")
});
export { br_history_key_recyclepumpsecs4 as "br_history_key_recyclePumpsECS" }